const routes = [
  // Olds
  // {
  //   path: '/relatorio/comparativo-estoque-sanepar',
  //   name: 'comparativoSanepar',
  //   component: () => import('@/views/relatorio/almoxarifado/ComparativoEstoqueSanepar.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Comparativo Estoque Sanepar' }],
  //   },
  // },
  // {
  //   path: '/relatorio/item-movimentacao',
  //   name: 'itemMovimentacao',
  //   component: () => import('@/views/relatorio/almoxarifado/ItensDiariosPorEquipe.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Movimentações diárias de materiais por equipe' }],
  //   },
  // },
  // {
  //   path: '/relatorio/estoque-deposito',
  //   name: 'estoqueDeposito',
  //   component: () => import('@/views/relatorio/almoxarifado/ItensEstoquePorDeposito.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Itens no Estoque por Depósito' }],
  //   },
  // },
  // {
  //   path: '/relatorio/estoque-equipe',
  //   name: 'estoqueEquipe',
  //   component: () => import('@/views/relatorio/almoxarifado/ItensEstoquePorEquipe.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Itens no Estoque por equipe' }],
  //   },
  // },
  // {
  //   path: '/relatorio/estoque-atual',
  //   name: 'estoqueAtual',
  //   component: () => import('@/views/relatorio/almoxarifado/EstoqueAtual.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Estoque Atual' }],
  //   },
  // },

  // {
  //   path: '/relatorio/saldo-atual',
  //   name: 'saldoAtual',
  //   component: () => import('@/views/relatorio/almoxarifado/SaldoAtual.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Saldo Atual' }],
  //   },
  // },
  // {
  //   path: '/relatorio/item-protocolo',
  //   name: 'itemProtocolo',
  //   component: () => import('@/views/relatorio/almoxarifado/ItensPorProtocolo.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Itens aplicados por protocolo' }],
  //   },
  // },
  // {
  //   path: '/relatorio/entrada-nota',
  //   name: 'entradaNota',
  //   component: () => import('@/views/relatorio/almoxarifado/ItensPorNotaFiscal.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Entrada de itens por Nota Fiscal' }],
  //   },
  // },
  // {
  //   path: '/relatorio/historico-movimentacao',
  //   name: 'HistoricoMovimentacao',
  //   component: () => import('@/views/relatorio/almoxarifado/HistoricoMovimentacao.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Histórico de Movimentações' }],
  //   },
  // },
  // {
  //   path: '/relatorio/inventario',
  //   name: 'Inventario',
  //   component: () => import('@/views/relatorio/almoxarifado/Inventario.vue'),
  //   meta: {
  //     breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Inventário' }],
  //   },
  // },
  //  News
  {
    path: '/relatorio/almoxarifado/execucao',
    name: 'execucaoAplicacao',
    component: () => import('@/views/relatorio/almoxarifado/ConsultaExecucaoPorEndereco.vue'),
    meta: {
      breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Execução ou Aplicação' }],
    },
  },
  {
    path: '/relatorio/almoxarifado/historico-movimentacoes-deposito',
    name: 'historicoMovimentacoesDeposito',
    component: () => import('@/views/relatorio/almoxarifado/ExecucaoAplicacao.vue'),
    meta: {
      breadcrumb: [{ title: 'Relatórios' }, { title: 'Almoxarifado' }, { title: 'Histórico de Movimentações por Depósito' }],
    },
  },
]

export default routes
